/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDataDto } from '../../models/document-data-dto';
import { DocumentInfoDto } from '../../models/document-info-dto';

export interface DocumentsUploadDocumentForCase$Params {
  'x-trace-id'?: string;
  casId: number;
      body: DocumentDataDto
}

export function documentsUploadDocumentForCase(http: HttpClient, rootUrl: string, params: DocumentsUploadDocumentForCase$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentInfoDto>> {
  const rb = new RequestBuilder(rootUrl, documentsUploadDocumentForCase.PATH, 'post');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.path('casId', params.casId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentInfoDto>;
    })
  );
}

documentsUploadDocumentForCase.PATH = '/api/documents/case/{casId}';
